import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '📘',
    title: 'TOMO 1',
    level: 'Evaluación y Banderas Rojas',
    content: 'Anamnesis, tests ortopédicos, señales de alerta y derivación'
  }, {
    emoji: '📗',
    title: 'TOMO 2',
    level: 'Pre-Habilitación Inteligente',
    content: 'Activación muscular, movilidad previa, fuerza preventiva'
  }, {
    emoji: '📙',
    title: 'TOMO 3',
    level: 'Post-Cirugía: Fase Aguda',
    content: 'Control del dolor, crioterapia, movilización pasiva temprana'
  }, {
    emoji: '📕',
    title: 'TOMO 4',
    level: 'Re-Educación de la Carga',
    content: 'Leg press, cadena cinética, progresión funcional'
  }, {
    emoji: '📓',
    title: 'TOMO 5',
    level: 'Retorno Deportivo y Salto',
    content: 'Tests de salto, criterios de alta deportiva, protocolos de carrera'
  }, {
    emoji: '📔',
    title: 'TOMO 6',
    level: 'Nicho 50+: Artrosis y Desgaste',
    content: 'Manejo del dolor crónico, adaptaciones para adulto mayor'
  }];
  const includes = ['Protocolo clínico listo para aplicar', 'Fichas fotocopiables por paciente', 'Criterios de progresión objetivos', 'Ejercicios con descripción técnica completa', 'Indicadores de alarma y contraindicaciones', 'Adaptado al contexto clínico argentino', '100% basado en evidencia actualizada'];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-225">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-227">
          {/* Header */}
          <div className="text-center mb-6 md:mb-12" data-id="element-228">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-2 md:mb-4" data-id="element-229">
              🏆 ATLAS DE LA RODILLA — PACK COMPLETO
            </h2>
            <p className="text-xl md:text-2xl text-amber-500 font-semibold mb-1 md:mb-2" data-id="element-230">
              6 Tomos + 3 Bonos — Evaluación → Retorno Deportivo
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-231">
              Todo resuelto.
            </p>
          </div>

          {/* Tomos Grid */}
          <div className="mb-8 md:mb-12" data-id="element-232">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 md:mb-8 text-center" data-id="element-233">
              📚 6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-234">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6" data-id="element-235">
                  <div className="text-4xl mb-3" data-id="element-236">{tomo.emoji}</div>
                  <h4 className="text-lg font-bold text-white mb-2" data-id="element-237">
                    {tomo.title}
                  </h4>
                  <p className="text-amber-500 font-semibold mb-3" data-id="element-238">
                    {tomo.level}
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed" data-id="element-239">
                    {tomo.content}
                  </p>
                </motion.div>)}
            </div>
          </div>

          {/* Includes */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6 md:p-8" data-id="element-240">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-241">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-242">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-243">
                  <CheckCircle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-244" />
                  <p className="text-gray-300" data-id="element-245">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}